import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowSwap32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconArrowSwap32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M22.044 14.543a1 1 0 0 0 1.414 1.414l4.242-4.243.707-.707-.707-.707-4.242-4.242a1 1 0 1 0-1.414 1.414L24.572 10H5a1 1 0 1 0 0 2h19.585zM9.708 17.457 7.165 20H27a1 1 0 1 1 0 2H7.18l2.528 2.528a1 1 0 0 1-1.415 1.414L4.052 21.7l-.707-.707.707-.707 4.243-4.243a1 1 0 0 1 1.414 1.414"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowSwap32);
